/**
 * Where the app points: API and web host.
 *
 * These are resolved at RUNTIME from `public/config.js`, which webpack copies
 * verbatim into the build and which the web server owns per environment. That
 * matters because web releases are promoted by copying build-dev over
 * build-prod - if the hosts were baked into the bundle, that copy would silently
 * point production at the dev API and dev database. Keeping them in a file the
 * server owns means one bundle serves both environments and the copy is always
 * safe (promotion rsyncs with --exclude config.js).
 *
 * The build-time REACT_APP_* values remain as a fallback so `npm start` and the
 * native Capacitor builds keep working unchanged. Capacitor bundles `build/`
 * into the app, so config.js ships inside the binary with whatever values it
 * was built with - for App Store builds that is production, which is correct.
 * If config.js were ever missing, the fallback keeps the app on the build-time
 * host rather than leaving it with no API at all.
 */

interface RuntimeConfig {
  apiHost?: string;
  webHost?: string;
}

declare global {
  interface Window {
    ccRuntimeConfig?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = (typeof window !== 'undefined' && window.ccRuntimeConfig) || {};

export const API_HOST: string = runtime.apiHost
  || process.env.REACT_APP_API_HOST
  || 'http://localhost:5000';

export const WEB_HOST: string = runtime.webHost
  || process.env.REACT_APP_WEB_HOST
  || 'http://localhost:5000';
